import { useNavigate } from "react-router-dom";
import { blogItems, formatBlogDate } from "./blogData";
import "./Blog.scss";

const Blog = () => {
  const navigate = useNavigate();

  const openBlog = (id: string) => {
    navigate(`/blog/${id}`);
  };

  const handleCardKeyDown = (event: React.KeyboardEvent<HTMLElement>, sectionLink: string) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openBlog(sectionLink);
    }
  };

  return (
    <section className="blog-page">
      <div className="blog-page__header" data-aos="fade-up">
        <span className="blog-page__eyebrow">Conteúdos Sodalita</span>
        <h1>Insights sobre saúde corporativa, produtividade e bem-estar</h1>
        <p>
          Informações práticas para apoiar empresas na construção de ambientes de trabalho
          mais saudáveis, humanos e produtivos.
        </p>
      </div>

      <div className="blog-page__grid">
        {blogItems.map((item) => (
          <article
            className="blog-page__card"
            key={item.title}
            onClick={() => openBlog(item.id)}
            onKeyDown={(event) => handleCardKeyDown(event, item.id)}
            role="button"
            tabIndex={0}
          >
            <img src={item.imageUrl} alt={item.title} className="blog-page__image" />
            <div className="blog-page__content">
              <h2>{item.title}</h2>
              <div className="blog-page__meta">
                <span>Por {item.author}</span>
                <span aria-hidden="true">•</span>
                <time dateTime={item.createdAt}>{formatBlogDate(item.createdAt)}</time>
                <span aria-hidden="true">•</span>
                <span>{item.readingTime} min de leitura</span>
              </div>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Blog;
